import * as React from 'react';

function ShoppingPointIcon({ 'aria-hidden': ariaHidden = true, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="31"
      height="37"
      viewBox="0 0 31 37"
      aria-hidden={ariaHidden}
      {...props}
    >
      <defs>
        <path
          id="3xxx6pnc8a"
          d="M7 0C5.002 0 3.38 1.623 3.38 3.62v2.173h.965V3.621C4.345 2.14 5.52.966 7 .966c1.48 0 2.655 1.175 2.655 2.655v2.172h.966V3.621C10.62 1.623 8.998 0 7 0zM1.207 6.759L0 18.793h14L12.793 6.76H1.207z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="#62D4D4"
                fillRule="nonzero"
                d="M26.475 4.506c-6.07-6.008-15.875-6.008-21.946 0-6.039 6.008-6.039 15.795 0 21.835L15.502 37l10.94-10.691c6.072-6.008 6.072-15.795.033-21.803z"
                transform="translate(-495.000000, -438.000000) translate(254.000000, 286.000000) translate(241.000000, 152.000000)"
              />
              <g>
                <path
                  d="M0 0H24V24H0z"
                  transform="translate(-495.000000, -438.000000) translate(254.000000, 286.000000) translate(241.000000, 152.000000) translate(3.500000, 4.000000)"
                />
                <g transform="translate(-495.000000, -438.000000) translate(254.000000, 286.000000) translate(241.000000, 152.000000) translate(3.500000, 4.000000) translate(5.000000, 2.000000)">
                  <mask id="ofavurkcqb" fill="#fff">
                    <use xlinkHref="#3xxx6pnc8a" />
                  </mask>
                  <use fill="#000" fillRule="nonzero" xlinkHref="#3xxx6pnc8a" />
                  <g fill="#179B92" mask="url(#ofavurkcqb)">
                    <path d="M0 0H24V24H0z" transform="translate(-5.000000, -2.000000)" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ShoppingPointIcon;
